import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './Typography.scss';

const withTypography = (element) => {
	const Component = ({
		children, className, eyebrow, size, color, last, squareBackground, underline,
		strikethrough, id, weight, highlight, circleBackground, hasIcon, rightSpacing, topSpacing, family
	}) => {
		const effectiveColor = eyebrow ? (color || 'gray') : color;
		const effectiveSize = eyebrow ? 'tiny' : size;

		return React.createElement(element, {
			id,
			className: classnames(
				className,
				'sf-type',
				!!highlight && `sf-type-highlight ${highlight}`,
				!!strikethrough && 'sf-type-strike',
				!!underline && 'sf-type-underline',
				!!last && 'sf-type-last',
				!!effectiveSize && `sf-type-${effectiveSize}`,
				!!effectiveColor && `sf-type-${effectiveColor}`,
				!!eyebrow && 'sf-type-eyebrow',
				!!weight && `sf-type-weight-${weight}`,
				!!circleBackground && 'sf-type-circle-background',
				!!squareBackground && `sf-type-square-background ${squareBackground}`,
				!!rightSpacing && 'sf-type-right-spacing',
				!!topSpacing && 'sf-type-top-spacing',
				!!hasIcon && 'sf-type-has-icon',
				!!family && `sf-type-family-${family}`,
			)
		}, children);
	};

	Component.displayName = element.toUpperCase();
	Component.propTypes = {
		size: PropTypes.oneOf(['tiny', 'small', 'smaller', 'standard', 'medium', 'tall', 'semiLarge', 'large', 'xlarge', 'huge']),
		color: PropTypes.oneOf(['red', 'gray', 'white', 'black', 'yellow', 'green', 'darkBlue', 'orange']),
		weight: PropTypes.oneOf(['light', 'standard', 'medium', 'bold', 'ultraBold']),
		highlight: PropTypes.oneOf(['yellow', 'green']),
		family: PropTypes.oneOf(['standard', 'rounded'])
	};

	return Component;
};

export const H1 = withTypography('h1');
export const H2 = withTypography('h2');
export const H3 = withTypography('h3');
export const H4 = withTypography('h4');
export const H5 = withTypography('h5');
export const H6 = withTypography('h6');
export const Paragraph = withTypography('p');
export const Text = withTypography('span');
